import {
  AddCommunicationway,
  Delete_One_Communicationway,
  Get_All_Communicationway,
  Get_Error,
  Get_One_Communicationway,
  Update_One_Communicationway,
} from '../Types';

const intial = {
  communicationway: [],
  Updatecommunicationway: [],
  loading: true,
};

const Communicationway_Reducer = (state = intial, action) => {
  switch (action.type) {
    case AddCommunicationway:
      return {
        ...state,
        communicationway: action.payload,
        loading: false,
      };
    case Get_All_Communicationway:
      return {
        ...state,
        communicationway: action.payload,
        loading: false,
      };
    case Delete_One_Communicationway:
      return {
        ...state,
        communicationway: action.payload,
        loading: false,
      };

    case Get_One_Communicationway:
      return {
        ...state,
        communicationway: action.payload,
        loading: false,
      };

    case Update_One_Communicationway:
      return {
        ...state,
        Updatecommunicationway: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        communicationway: action.payload,
      };
    default:
      return state;
  }
};

export default Communicationway_Reducer;
